import { sortBy } from 'lodash';

import { calculatePercentageTotal, calculatePercentageValue } from '@phoenix/core/frontend/shared/util/math';
import {
  CompatibleProductBattery as ServiceCompatibleBattery,
  ProductCompatibleBattery as ServiceProductCompatibleBattery,
} from '@phoenix/team-m/dashboard/frontend/domain/generated/graphql';

import { ProductCompatibleBatteries, CompatibleBattery, RuntimePercentages } from './product-batteries.model';
import { mapProductCategory } from './product.mapper';

const sortByRuntime = (batteries: ServiceCompatibleBattery[]) => sortBy(batteries, (b) => b.maxRuntime).reverse();

const filterCompatibleBatteries = (batteries: ServiceCompatibleBattery[]) =>
  batteries.filter((b) => !b.isOwned && !!b.runtimeStats?.runtimeBoostPercentage && !!b.runtimeStats?.runtimeBoost);

const getRuntimePercentages = (baseRuntime: number, runtime: number, runtimePercentage: number): RuntimePercentages => {
  const percentageTotal = calculatePercentageTotal(runtime, runtimePercentage);
  const baseRuntimePercentage = calculatePercentageValue(baseRuntime ?? 0, percentageTotal);
  return [baseRuntimePercentage, runtimePercentage - baseRuntimePercentage];
};

const mapCompatibleBatteries = (batteries: ServiceCompatibleBattery[]): CompatibleBattery[] =>
  sortByRuntime(batteries).map((battery, i) => ({
    ...battery,
    runtimePercentages: getRuntimePercentages(
      battery.runtimeStats?.baseRuntime ?? 0,
      battery.maxRuntime,
      battery.runtimeStats?.runtimeBoostPercentage as number
    ),
    runtimeIncrease: battery.runtimeStats?.runtimeBoost as number,
    imageUrl: battery.imageUrl ?? '',
    callToActionUrl: battery.callToActionUrl ?? '',
    index: i + 1,
  }));

export const reduceProductsWithLagerCapacityBatteries = (products?: ServiceProductCompatibleBattery[]): ProductCompatibleBatteries[] =>
  (products ?? []).reduce((prev, curr) => {
    const compatibleBatteries = filterCompatibleBatteries(curr.compatibleBatteries);
    if (compatibleBatteries.length) {
      return [
        ...prev,
        {
          ...curr,
          compatibleBatteries: mapCompatibleBatteries(compatibleBatteries),
          imageUrl: curr.imageUrl ?? '',
          category: mapProductCategory(curr.category),
        },
      ];
    }

    return prev;
  }, []);
